import MapLoader from 'google-maps';
import turf from 'turf'
import pointToLineDistance from '@turf/point-to-line-distance'
import simplify from 'simplify-js'
import Tolls from '../../../services/toll'
import Route from '../../../services/route'
import {cents} from '../../../filters/number'

export default {
  data(){
    return {
      google: undefined,
      map: undefined,
      markers: [],
      axes: 2,
      directionsService: undefined,
      originAc: undefined,
      destinationAc: undefined,
      wayPoints: [],
      qtdWayPoints: 0,
      msgError: undefined,
      loading: undefined,
      distance: undefined,
      qtdTolls: undefined,
      valueTolls: undefined,
      showSummary: false,
      coord: undefined,
      all: undefined,
      duration: undefined,
      result: {start: undefined, end: undefined, wayPoints: undefined, tolls: undefined,
              totalDistance: undefined, totalTime: undefined, totaltollFeeCost: undefined},
      image: undefined,
      associateId: undefined
    }
  },

  created(){
    let promise = Tolls.getTolls().then(r => {
      
      this.all = r;
      this.putPin(this.all);
    }).catch(err => {
      
    });
    this.$store.dispatch('loading', promise);

  },

  mounted(){
    $('[data-toggle="tooltip"]').tooltip();
    let vm = this;

    MapLoader.KEY = 'AIzaSyAzAwCX1zCJ9idWkNdxs39j36N4lAToIjE';
    MapLoader.LIBRARIES = ['places'];
    MapLoader.load(function(google) {
      vm.google = google;
      vm.map = new google.maps.Map(document.getElementById('map'), {
        zoom: 4,
        center: {"lat":-21.009377008304,"lng":-48.17694799974561}
      });

      vm.directionsDisplay = new google.maps.DirectionsRenderer({
        draggable: true,
        suppressMarkers: true
      });
      vm.directionsDisplay.setMap(vm.map);

      vm.directionsService = new google.maps.DirectionsService();

      vm.directionsDisplay.addListener("directions_changed", function() {
        vm.updateNewDirections();
      });


      //vm.route("Manaus", "Santos");
      //vm.putPin(vm.all);

      vm.initAutoCompletes();

    });
  },

  methods:{

    afterUpdateDirections(){
      //Sobrescrever este metodo, que sera chamado apos a rota estar completa com todos os pedagios
    },

    plotAssociate(){
      let t = _.filter(this.all, (o) => {
        o.price = 0;
        return o.associateId == this.associateId
      });
      this.reset();
      this.putPin(t);
    },

    placeToPointLocation(place, sequence, type){
      let p = {
        type: type,
        sequence: sequence
      };
      _.each(place.address_components, function(o){
        if(_.indexOf(o.types, 'postal_code') >= 0)
          p.zipCode = o.short_name;
        else if(_.indexOf(o.types, 'administrative_area_level_1') >= 0)
          p.state = o.short_name;
        else if(_.indexOf(o.types, 'administrative_area_level_2') >= 0)
          p.city = o.short_name;
        else if(_.indexOf(o.types, 'sublocality') >= 0)
          p.neighborhood = o.short_name;
        else if(_.indexOf(o.types, 'route') >= 0)
          p.address = o.short_name;
        else if(_.indexOf(o.types, 'street_number') >= 0)
          p.number = o.short_name;
        else if(_.indexOf(o.types, 'country') >= 0)
          p.country = o.short_name;
      });
      try{
        p.address = place.formatted_address;
        p.lat = place.geometry.location.lat();
        p.lng = place.geometry.location.lng();
      } catch(err){
        
      }
      return p;
    },

    // TODO remover
    plotar(){
      let pos = this.coord.trim().split(",");
      let marker = new google.maps.Marker({
        position: {lat: parseFloat(pos[0]), lng: parseFloat(pos[1])},
        map: this.map
      });

      let contentString = this.coord;

      let infowindow = new google.maps.InfoWindow({
        content: this.coord
      });

      marker.addListener('click', function() {
        infowindow.open(this.map, marker);
      });

      this.markers.push(marker);


    },

    inverter(){
      let origin = document.getElementById('origin').value;
      let destination = document.getElementById('destination').value;
      document.getElementById('origin').value = destination;
      document.getElementById('destination').value = origin;
      this.calculate();

    },

    initAutoCompletes(){

      var options = {
        //types: ['(regions)'],
        componentRestrictions: {country: 'br'}
      };

      this.originAc = new google.maps.places.Autocomplete(document.getElementById('origin'), options);
      this.destinationAc = new google.maps.places.Autocomplete(document.getElementById('destination'), options);

    },
    putPin(tolls){
      _.each(tolls, (o) => {
          

          let marker = new google.maps.Marker({
            icon: o.id > 0 ? '/static/pins/pin-toll.png' : '/static/pins/pin-toll-inactive.png',
            position: o,
            map: this.map
          });

          let content = `<p>${o.associateId} - ${o.entryId} - ${o.direction} - ${o.radius}</p>`;
          if(o.id < 0)
            content += `<div class="box-toll-map"><h4 class="title-toll">${o.description}</h4><span class="text-toll-inactive">Pedágio não atendido pela Move Mais.</span></div>`;
          else
            content += `<div class="box-toll-map"><h4 class="title-toll">${o.description}</h4><span class="text-toll">Valor do Pedágio: </span><span class="text-toll-value">${cents(o.price)}</span></div>`;

          let infowindow = new google.maps.InfoWindow({
            content: content
          });

          marker.addListener('click', function() {
            infowindow.open(this.map, marker);
          });

          this.markers.push(marker);

      });

    },

    setRouteMarkers(direction){

      let legs = direction.routes[0].legs


      let start = legs[0].start_location;
      let marker = new this.google.maps.Marker({
        position: start,
        icon: '/static/pins/pin-origin.png',
        map: this.map
      });
      this.markers.push(marker);
      this.result.start = start;

      let end = legs[legs.length-1].end_location;
      marker = new this.google.maps.Marker({
        position: end,
        icon: '/static/pins/pin-destination.png',
        map: this.map,
        zIndex: 999,
        optimized: false
      });
      this.markers.push(marker);
      this.result.end = end;

      this.result.wayPoints = [];
      // coloca os WayPoints
      for(var i=1; i<legs.length; i++){
        
        let wayPoint = legs[i].start_location;
        
        this.result.wayPoints.push(wayPoint);
        let marker2 = new this.google.maps.Marker({
          position: wayPoint,
          icon: '/static/pins/pin-waypoint.png',
          map: this.map
        });

        let infowindow = new google.maps.InfoWindow({
          content: `<div>${legs[i].start_address}</div>`
        });

        marker2.addListener('click', function() {
          infowindow.open(this.map, marker2);
        });

        this.markers.push(marker2);

      }
    },

    updateNewDirections(){
      try {
        this.loading = new Promise(function(resolve, reject){});
        let vm = this;
        this.reset();
        
        let tolls = vm.discoveryTolls(vm.directionsDisplay.getDirections());
        
        Tolls.getPriceTolls({tolls: tolls.tolls, axes: this.axes}).then(r => {
          tolls.tolls = r.tolls;
          vm.putPin(tolls.tolls);
          this.result.tolls = tolls.tolls;
          this.result.totaltollFeeCost = r.totalValue;
          this.result.totalDistance = Math.round(tolls.totalRoute / 1000);
          this.result.totalTime = tolls.totalDuration;
          vm.setRouteMarkers(vm.directionsDisplay.getDirections());
          vm.showSummary = true;
          this.afterUpdateDirections();

        });
      } catch(err){
        
      }
      this.loading = Promise.reject(false);
    },

    cleanMarkers(){
      for (var i = 0; i < this.markers.length; i++) {
        this.markers[i].setMap(null);
      }
      this.markers = [];

    },

    reset(){
      this.cleanMarkers();
    },

    calculate(){
      
      
      this.msgError = undefined;
      this.loading = new Promise(function(resolve, reject){});
      
      
      let origin = document.getElementById('origin').value;
      let destination = document.getElementById('destination').value;

      let vm = this;
      let req = {
        origin: origin,
        destination: destination,
        travelMode: this.google.maps.TravelMode.DRIVING
      };

      if(this.qtdWayPoints > 0){
        req.waypoints = [];
        for(var i=0; i<this.qtdWayPoints; i++){
          req.waypoints.push({location: document.getElementById('waypoint'+i).value});
        }
      }
      

      vm.directionsService.route(req, function(result, status) {
          
          if (status === this.google.maps.DirectionsStatus.OK) {
            //
            vm.directionsDisplay.setDirections(result);

          } else {
            this.msgError = "Não foi possível calcular a rota, tente especificar melhor a origem, o destino e os pontos de passagem (se existirem).";
            this.loading = Promise.reject(false);
          }
      });

    },

    showSavedRoute(points){
      //let simpl = simplify(points, 0.00001, false);
      
      
      
      
      var rota = new google.maps.Polyline({
        path: points,
        geodesic: true,
        strokeColor: '#FF0000',
        strokeOpacity: 0.6,
        strokeWeight: 2
      });

      rota.setMap(vm.map);

    },

    discoveryTolls(result){
      let pointsLeg = []; //pontos de cada trecho
      let pointsGoogle = []; //pontos no formato do google para salvar a rota e exibir posterioemente
      let legs = result.routes[0].legs;

      let totalRoute = 0;
      let totalDuration = 0;
      //itera todos os pontos que compoem a rota
      for (var i = 0; i < legs.length; i++) {
        pointsLeg[i] = [];
        totalRoute += legs[i].distance.value;
        totalDuration += legs[i].duration.value;
        for (var j = 0; j < legs[i].steps.length; j++) {
          for (var k = 0; k < legs[i].steps[j].path.length; k++) {
            var p = legs[i].steps[j].path[k];
            pointsLeg[i].push([p.lng(), p.lat()]);
            p.y = p.lat();
            p.x = p.lng();
            pointsGoogle.push(p);
          }
        }
      }
      
      let tollsDirection = [];
      let totalTolls = 0;

      for(var leg=0; leg<pointsLeg.length; leg++) {
        let points = pointsLeg[leg];
        let line = turf.lineString(points);//rota

        let tolls = [];//pedagios a x kilometros da rota
        let all = this.all;
        for(var i=0; i<all.length; i++){
          let p = turf.point([all[i].lng, all[i].lat]);
          let d = pointToLineDistance(p, line, {units: 'kilometers'});
          //let pl = turf.pointOnLine(line, p);
          //all[i].pointOnLine = pl;
          if(d * 1000 < all[i].radius){
            
            all[i].dist = d;
            tolls.push(all[i]);
          }
        }

        for(var i=0; i<tolls.length; i++){


          let p = 0; // ponto da rota mais proximo
          let menorDistancia = 200; // menor distancia
          for(let j=1; j<points.length; j++){
            let auxD = turf.distance(this.toTurfPoint(tolls[i]), points[j]);
            if(auxD < menorDistancia){
              p = j;
              menorDistancia = auxD;
            }
          }

          
          let pontoAntesDoPedagio = points[p-1];
          let direction = tolls[i].direction;
          //var angle = turf.bearing(pontoAntesDoPedagio, this.toTurfPoint(tolls[i]));
          var angle = turf.bearing(pontoAntesDoPedagio, turf.pointOnLine(line, this.toTurfPoint(tolls[i])));
          

          if (direction == "A"
              || (direction == "N" && (angle >= -90 && angle <= 90))
              || (direction == "S" && (angle <= -90 || angle >= 90))
              || (direction == "L" && (angle >= 0 && angle <= 180))
              || (direction == "O" && (angle >= -180 && angle <= 0))) {

              tolls[i].angle = angle;
              tolls[i].distanciaPedagioPontoAnterior = turf.distance(this.toTurfPoint(tolls[i]), pontoAntesDoPedagio);
              //tollsDirection.push({lat: pontoAntesDoPedagio[1], lng: pontoAntesDoPedagio[0]});

              tollsDirection.push(tolls[i]);

          }

        }
      }

      
      return {tolls: tollsDirection, totalRoute: totalRoute, totalDuration: totalDuration};


    },

    toTurfPoint(obj){
      return [obj.lng, obj.lat];
    },

    addWayPoint(){
      let options = {
        types: ['geocode'],
        componentRestrictions: {country: 'br'},
        suppressMarkers: true
      };

      if(this.qtdWayPoints < 20){
        let i = this.qtdWayPoints++;
        
        if(!this.wayPoints[i]){
          
          this.wayPoints[i] = new google.maps.places.Autocomplete(document.getElementById('waypoint'+i), options);
        }
      }
    },

    removeWayPoint(){
      if(this.qtdWayPoints > 0)
        this.qtdWayPoints--;
    }

  }
}




// WEBPACK FOOTER //
// ./src/pages/account/routing/rounting-teste.js